import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import Fraction from '../game/Fraction';
import Monster from '../game/Monster';
import { playGameJingle } from '../JingleController';
import SoundAssetKeys from '../SoundAssetKeys';
import FractionTile from '../ui/FractionTile';
import { dotPop } from '../Utilities';
import Instructions from './Instructions';

export default class Title extends Phaser.Scene {
    static get KEY() { return 'Title'; }

    constructor() {
        super({ key: (Title).KEY });
    }

    init() {
        this.title = null;
        this.btnGo = null;

        this.fractionTile1 = null;
        this.fractionTile2 = null;

        this.monster = null;
    }

    create() {
        playGameJingle();

        this.add.image(0,0, "bg").setOrigin(0);

        let test = new Fraction( 1,4);
        this.fractionTile1 = new FractionTile(this);
        this.fractionTile1.setValue(test);
        this.fractionTile1.select();

        test = new Fraction( 3,4);
        this.fractionTile2 = new FractionTile(this);
        this.fractionTile2.setValue(test);
        this.fractionTile2.select();

        let tweenSpeed = 1.0;

        this.fractionTile1.centerContainer();
        this.fractionTile1.x = 607;
        this.fractionTile1.y = 938;
        this.fractionTile1.angle = 170;
        this.tweens.timeline({
            tweens:
            [
                ABCyaPhaser.Tweens.createTween(this.fractionTile1, 1375/tweenSpeed, {x:913, y: 354}, Phaser.Math.Easing.Linear, ()=> this.playSound()),
                ABCyaPhaser.Tweens.createTween(this.fractionTile1, 750/tweenSpeed, {angle: 233, x:657, y: 117}, Phaser.Math.Easing.Linear, ()=> this.playSound()),
                ABCyaPhaser.Tweens.createTween(this.fractionTile1, 1458/tweenSpeed, {angle: -20, x:162, y: 259}, Phaser.Math.Easing.Linear, ()=> this.playSound()),
            ]
        });

        this.fractionTile2.centerContainer();
        this.fractionTile2.setScale(0.8);
        this.fractionTile2.x = -221;
        this.fractionTile2.y = 405;
        this.fractionTile2.angle = -45;
        this.tweens.timeline({
            tweens:
            [
                ABCyaPhaser.Tweens.createTween(this.fractionTile2, 1041/tweenSpeed, {delay: 966/tweenSpeed, x:408, y: 677}, Phaser.Math.Easing.Linear, ()=> this.playSound()),
                ABCyaPhaser.Tweens.createTween(this.fractionTile2, 1576/tweenSpeed, {angle: 26, x:826, y: 230}, Phaser.Math.Easing.Linear, ()=> this.playSound()),
            ]
        });
        this.add.existing(this.fractionTile1);
        this.add.existing(this.fractionTile2);

        this.monster = new Monster(this);
        this.monster.x = this.scale.width - this.monster.workingWidth - 20;
        this.monster.y = -300;
        ABCyaPhaser.Tweens.addTween(this.monster, 600, {y: this.scale.height-this.monster.workingHeight-20, delay: 3300}, Phaser.Math.Easing.Linear, ()=> this.showGo());
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._whistle_down, this, 1, false, 3.3);
        this.add.existing(this.monster);

        this.title = ABCyaPhaser.Images.addImage(this.scale.width/2,this.scale.height/2, "Title", this).setOrigin(0.5).setScale(0);
        this.btnGo = ABCyaPhaser.Images.addImage(this.scale.width/2,this.scale.height-100, "BtnGo", this).setOrigin(0.5).setScale(0);

        dotPop(this.title, 440);
    }

    playSound () {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._thump, this);
    }

    showGo() {
        dotPop(this.btnGo);
        this.btnGo.setInteractive().once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickGo, this);
    }

    clickGo () {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
        this.scene.start(Instructions.KEY);
    }

    update(time, dt) {
        this.monster.tick(dt/1000);
    }
}